export default {
  'common.save': 'บันทึก',
  'common.cancel': 'ยกเลิก',
  'common.delete': 'ลบ',
  'common.edit': 'แก้ไข',
  'common.confirm': 'ยืนยัน',
  'common.close': 'ปิด',
  'common.search': 'ค้นหา',
  'common.loading': 'กำลังโหลด...',
  'common.processing': 'กำลังประมวลผล...',
  'common.submit': 'ส่ง',
  'common.back': 'ย้อนกลับ',
  'common.next': 'ถัดไป',
  'common.previous': 'ก่อนหน้า',
  'common.upload': 'อัปโหลด',
  'common.download': 'ดาวน์โหลด',
  'common.downloadAll': 'ดาวน์โหลดทั้งหมด',
  'common.refresh': 'รีเฟรช',
  'common.retry': 'ลองอีกครั้ง',
  'common.copy': 'คัดลอก',
  'common.copied': 'คัดลอกแล้ว',
  'common.selectAll': 'เลือกทั้งหมด',
  'common.clear': 'ล้าง',
  'common.clearAll': 'ล้างทั้งหมด',
  'common.apply': 'นำไปใช้',
  'common.reset': 'รีเซ็ต',
  'common.filter': 'ตัวกรอง',
  'common.sort': 'จัดเรียง',
  'common.export': 'ส่งออก',
  'common.import': 'นำเข้า',
  'common.preview': 'ตัวอย่าง',
  'common.view': 'ดู',
  'common.add': 'เพิ่ม',
  'common.remove': 'นำออก',
  'common.rename': 'เปลี่ยนชื่อ',
  'common.share': 'แชร์',
  'common.settings': 'การตั้งค่า',
  'common.logout': 'ออกจากระบบ',
  'common.profile': 'โปรไฟล์',
  'common.yes': 'ใช่',
  'common.no': 'ไม่',
  'common.ok': 'ตกลง',
  'common.areYouSure': 'คุณแน่ใจหรือไม่?',
  'common.actionCannotBeUndone': 'การดำเนินการนี้ไม่สามารถย้อนกลับได้',
  'common.noData': 'ไม่มีข้อมูล',
  'common.noResultsFound': 'ไม่พบผลลัพธ์',
  'common.somethingWentWrong': 'เกิดข้อผิดพลาด',
  'common.pleaseTryAgain': 'กรุณาลองอีกครั้ง',
  'common.success': 'สำเร็จ',
  'common.error': 'ข้อผิดพลาด',
  'common.warning': 'คำเตือน',
  'common.info': 'ข้อมูล',
  'common.optional': 'ไม่บังคับ',
  'common.required': 'จำเป็นต้องกรอก',
  'common.name': 'ชื่อ',
  'common.title': 'ชื่อเรื่อง',
  'common.description': 'คำอธิบาย',
  'common.status': 'สถานะ',
  'common.actions': 'การดำเนินการ',
  'common.date': 'วันที่',
  'common.time': 'เวลา',
  'common.createdAt': 'สร้างเมื่อ',
  'common.updatedAt': 'อัปเดตเมื่อ',
  'common.type': 'ประเภท',
  'common.size': 'ขนาด',
  'common.file': 'ไฟล์',
  'common.folder': 'โฟลเดอร์',
  'common.files': 'ไฟล์',
  'common.folders': 'โฟลเดอร์',
  'common.all': 'ทั้งหมด',
  'common.none': 'ไม่มี',
  'common.send': 'ส่ง',
  'common.sending': 'กำลังส่ง...',
  'common.new': 'ใหม่',
  'common.create': 'สร้าง',
  'common.duplicate': 'ทำสำเนา',
  'common.move': 'ย้าย',
  'common.moveTo': 'ย้ายไปยัง',
  'common.selectFile': 'เลือกไฟล์',
  'common.chooseFile': 'เลือกไฟล์',
  'common.dragDropFilesHere': 'ลากและวางไฟล์ที่นี่',
  'common.or': 'หรือ',
  'common.browse': 'เรียกดู',
  'common.continue': 'ดำเนินการต่อ',
  'common.skip': 'ข้าม',
  'common.done': 'เสร็จสิ้น',
  'common.finish': 'เสร็จสิ้น',
  'common.start': 'เริ่ม',
  'common.stop': 'หยุด',
  'common.pause': 'หยุดชั่วคราว',
  'common.resume': 'ดำเนินการต่อ',
  'common.enabled': 'เปิดใช้งาน',
  'common.disabled': 'ปิดใช้งาน',
  'common.active': 'ใช้งานอยู่',
  'common.inactive': 'ไม่ได้ใช้งาน',
  'common.draft': 'ฉบับร่าง',
  'common.published': 'เผยแพร่แล้ว',
  'common.archive': 'เก็บถาวร',
  'common.unarchive': 'เลิกเก็บถาวร',
  'common.favourite': 'รายการโปรด',
  'common.favourites': 'รายการโปรด',
  'common.pin': 'ปักหมุด',
  'common.unpin': 'เลิกปักหมุด',
  'common.expand': 'ขยาย',
  'common.collapse': 'ย่อ',
  'common.showMore': 'แสดงเพิ่มเติม',
  'common.showLess': 'แสดงน้อยลง',
  'common.language': 'ภาษา',
  'common.darkMode': 'โหมดมืด',
  'common.lightMode': 'โหมดสว่าง',
  'common.help': 'ช่วยเหลือ',
  'common.feedback': 'ข้อเสนอแนะ',
  'common.notifications': 'การแจ้งเตือน',
  'common.rows': 'แถว',
  'common.column': 'คอลัมน์',
  'common.total': 'ทั้งหมด',
  'common.page': 'หน้า',
  'common.of': 'จาก',
  'common.notes': 'บันทึก',
};
